<template>
    <v-img
        :src="'/img/challenge/' + challenge_id + '/data_page.jpeg?kasi732'"
        class="grey lighten-2"
        style="width: 100%;"
    >
        <template v-slot:placeholder>
            <v-layout
                fill-height
                align-center
                justify-center
                ma-0
            >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
        </template>
    </v-img>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Banner",
    computed: {
        ...mapState({
            challenge_id: state => state.challenge.challenge.id
        })
    },
    props: {
        type: {
            type: String,
            default: 'data'
        }
    }
}
</script>

<style scoped>

</style>
